var jsShare = '.tools-panel[data-template="static-in-column"] .js-share', // js-share element for 'static-in-column' template
		jsShareList = '.tools-panel[data-template="static-in-column"] .js-share-list'; // js-share-list element for 'static-in-column' template

function toogleShareList() {
	var $this = $(this);
	if ($this.hasClass('is-expand')) {
		$.Velocity($this.siblings('.js-share-list'), 'slideUp', 200)
			.then(function () {
				$this
					.removeClass('is-expand')
					.siblings('.js-share-list')
					.removeClass('is-expand');
			})
			.catch(console.error);
	} else {
		$this
			.addClass('is-expand')
			.siblings('.js-share-list')
			.addClass('is-expand')
			.velocity('slideDown', 200);
	}
}

//Обработка событий
$(jsShare).on('click', function (event) {
	event.preventDefault();
	toogleShareList.apply(this);
});

$(document).on('click', function (event) {
	if (!$(event.target).closest(jsShare + ',' + jsShareList).length) {
		$.Velocity($(jsShareList), 'slideUp', 200)
			.then(function () {
				$(jsShare)
					.removeClass('is-expand')
					.siblings('.js-share-list')
					.removeClass('is-expand');
			})
			.catch(console.error);
	}
});



/** WEBPACK FOOTER **
 ** ./frontend/components/tools-panel/static-in-column/static-in-column.js
 **/